import React, { useEffect } from 'react';
import { Row, Col, Tag } from 'antd';
import WorkflowButtons from '../apps/common/WorkFlowButtons';

interface StatusBarProps {
  status?: string | null;
  id?: string | number | null;
  setStatus?: React.Dispatch<React.SetStateAction<string | null>> | null;
  wfActions?: string[] | null;
  currentType?: 'edit' | 'create' | 'view' | null;
  workflowType?: 'product_registration' | 'pre-clearance' | 'import' | 'follow-up' | 'lab' | 'np' | '' | null;
  onViewInvoicesClick?: any | null;
  failureActions?: any[];
  triggerRefresh?: any;
}

const StatusBar: React.FC<StatusBarProps> = ({
  status,
  id,
  setStatus,
  wfActions,
  currentType,
  workflowType,
  onViewInvoicesClick,
  failureActions,
  triggerRefresh,
}) => {
  useEffect(() => {
    // console.log('Workflow Details:');
    // console.log('ID:', id);
    // console.log('Status:', status);
    console.log('Workflow Actions:', wfActions);
    // console.log('Workflow Type:', workflowType);
  }, [id, status, wfActions, workflowType]);

  // Separate effect to monitor status updates
  // useEffect(() => {
  //   console.log('Updated Status:', status);
  // }, [status]);

  const statusLabels: { [key: string]: string } = {
    DRAFT: 'Draft',
    PENDING_TA: 'Pending Test Assignment',
    PENDING_PAYMENT: 'Pending Payment',
    PENDING_ITR: 'Pending Initial Test Results',
    PENDING_ITRA: 'Pending ITR Approval',
    PENDING_FRS: 'Pending Final Results Approval',
    PENDING_FA: 'Pending Final Approval',
    DONE: 'Done',
    PENDING_MA: 'Pending Manufacture Assignment',
    PENDING_IA: 'Pending Item Approval',
    PENDING_COLLECTION: 'Pending Collection',
    ACTIVE: 'Active',
    REJECT: 'Rejected',
    COMPLETE: 'Complete',
  };

  const showWorkflowButtons = currentType === 'view';

  const statusLabel = statusLabels[status || ''] || status;

  const tagColor = status === 'COMPLETE' || status === 'ACTIVE' ? 'green' : status === 'REJECT' ? 'red' : 'orange';

  return (
    <Row
      justify="space-between"
      align="middle"
      style={{
        padding: '10px',
        background: 'white',
        borderRadius: '5px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        height: '60px',
        display: 'flex',
        flexWrap: 'wrap',
      }}
    >
      <Col flex="1">
        {id && status && showWorkflowButtons ? (
          <Row gutter={[8, 8]} wrap style={{ gap: '8px' }}>
            <WorkflowButtons
              id={id}
              status={status}
              wfActions={wfActions || []}
              setStatus={setStatus as React.Dispatch<React.SetStateAction<string | null>>}
              workflowType={workflowType || null}
              onViewInvoicesClick={onViewInvoicesClick}
              failureActions={failureActions || []}
              triggerRefresh={triggerRefresh}
            />
          </Row>
        ) : null}
      </Col>
      <Col>
        <span style={{ fontWeight: 'bold' }}>Status:</span>{' '}
        {status ? <Tag color={tagColor}>{statusLabel}</Tag> : <Tag color="default">N/A</Tag>}
      </Col>
    </Row>
  );
};

export default StatusBar;
